//Styles
import assessFormStyles from "../../../../../styles/assessments/AssessmentForm.module.css"
import QuestionInputMatrixInput from "./QuestionInputMatrixInput"

export default function QuestionInputMatrix({
  question,
  answers,
  onUpdateAnswers,
  readOnly,
}) {
  let labelMinWidth = 25
  let optionWidth

  if (!question?.options) {
    labelMinWidth = 80
    optionWidth = 20
  } else {
    optionWidth = (100 - labelMinWidth) / question.options.length
  }

  return (
    <table className={assessFormStyles.matrixQuestionTable}>
      <thead>
        <tr>
          <th
            style={{ minWidth: `${labelMinWidth}%` }}
            className={assessFormStyles.matrixQuestionOptionTextHeader}
          ></th>
          {question.options
            ?.filter((option) => !option.isDeleted)
            .map((option) => (
              <th
                className={assessFormStyles.matrixQuestionOptionHeader}
                style={{ width: `${optionWidth}%` }}
                key={`${option.id}`}
              >
                {option.text}
              </th>
            ))}
        </tr>
      </thead>
      <tbody>
        {question.questionLabels
          ?.filter((label) => !label.isDeleted)
          .map((label) => (
            <tr key={label.id}>
              <td className={assessFormStyles.matrixQuestionOptionTextColumn}>
                {label.text}
              </td>
              {question.options
                ?.filter((option) => !option.isDeleted)
                .map((option) => (
                  <td
                    className={assessFormStyles.matrixQuestionOptionColumn}
                    key={option.id}
                  >
                    <QuestionInputMatrixInput
                      label={label}
                      option={option}
                      answers={answers}
                      question={question}
                      readOnly={false}
                      onChange={onUpdateAnswers}
                    />
                  </td>
                ))}
            </tr>
          ))}
      </tbody>
    </table>
  )
}
